

export const veoHero = {
    title: 'AI 影片生成器',
    desc:
      '體驗電影級的 AI 影片創作，支援關鍵幀模式、片段延長（超過 8 秒）、原生音訊同步，並帶來真實運動生成、多圖參考控制與 1080P 畫質。從文字或圖片到專業影片，立即開始創作。'
  };
